(function() {
    'use strict';

    angular.module('app').controller('EtoIntegrationController', EtoIntegrationController);

    EtoIntegrationController.$inject = [
        '$http',
        '$stateParams',
    ];

    function EtoIntegrationController($http, $stateParams) {
        var $ctrl = this;

        $ctrl.status = 'loading';
        $ctrl.verified = false;

        $ctrl.account = false;

        if ($stateParams.hash) {
            $ctrl.hash = $stateParams.hash;
        }

        $ctrl.form = {
            access: $ctrl.hash,
            password: '',
        };

        $ctrl.isSuccess = function() {
            return $ctrl.status === 'success';
        };

        $ctrl.send = function() {
            return __send().then(function(response) {
                if (response) {
                    $ctrl.status = 'success';

                    $ctrl.verified = false;
                }
            });
        };

        function __send() {
            return $http
                .post('/api/integration/eto/account', $ctrl.form)
                .then(function(response) {
                    return response.data.data;
                })
                .catch(function(err) {
                    $ctrl.status = 'error.password';

                    if (err.status === 422) {
                        $ctrl.status = 'error.account';
                    }
                });
        }

        function __verify() {
            return $http
                .post('/api/integration/eto/verify', {
                    hash: $ctrl.hash,
                })
                .then(function(response) {
                    return response.data.data;
                })
                .catch(function(err) {
                    $ctrl.status = 'error.general';

                    if (err.status === 404) {
                        $ctrl.status = 'error.hash';
                    }
                });
        }

        function init() {
            __verify().then(function(response) {
                if (response) {
                    $ctrl.account = 'etoll@' + response;
                    $ctrl.status = 'enter';

                    $ctrl.verified = true;
                }
            });
        }

        init();
    }
})();
